import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { takeQueryParams } from '../../../libs/historyHelper'
import { AppRootState } from '../../../store/types'
import { isVendorLoggedInSelector } from '../selectors'

const REDIRECT_TO_PAYMENT_KEY = 'to_payment'

export default function useRedirectToPaymentAfterVendorLogin(): boolean {
  const isVenderLoggedIn = useSelector((state: AppRootState) =>
    isVendorLoggedInSelector(state.user, state.ui),
  )
  const [redirectToPayment, setRedirectToPayment] = useState(false)
  useEffect(() => {
    const queryParams = takeQueryParams([REDIRECT_TO_PAYMENT_KEY])
    const redirectToPaymentValue = queryParams[REDIRECT_TO_PAYMENT_KEY]
    if (
      typeof redirectToPaymentValue === 'string' &&
      redirectToPaymentValue.length > 0
    ) {
      setRedirectToPayment(true)
    }
  }, [])
  return redirectToPayment && isVenderLoggedIn
}
